import {
	Center,
	ScrollArea,
	type ScrollAreaProps,
	Space,
	Table,
	Text,
} from '@mantine/core';
import type { UseQueryResult } from 'react-query';
import { LoadingRows } from '../../../components/LoadingRows';
import type { ApiResponse } from '../../../util/types/Response';
import type { BarcodeDto } from '../types/BarcodeDto';
import { BarcodeTableRow } from './BarcodeTableRow';
import { KeyedRow } from '../../../components/KeyedRow';

interface BarcodesTableProps extends ScrollAreaProps {
	barcodesQuery: UseQueryResult<ApiResponse<BarcodeDto[]>, unknown>;
	skuid: string;
}

export function BarcodesTable({
	barcodesQuery,
	skuid,
	...scrollAreaProps
}: BarcodesTableProps) {
	return (
		<>
			<ScrollArea {...scrollAreaProps}>
				<Table
					stickyHeader
					withRowBorders
					bg={'white'}
				>
					<Table.Thead>
						<KeyedRow>
							<Table.Th>Barcode</Table.Th>
							<Table.Th>Description</Table.Th>
							<Table.Th>Price</Table.Th>
							<Table.Th w={'2vw'} />
						</KeyedRow>
					</Table.Thead>
					<Table.Tbody>
						{barcodesQuery.isLoading ? (
							<LoadingRows columnSpan={200} rows={2} />
						) : (
							<>
								{skuid &&
									barcodesQuery.data?.value.map((b) => (
										<BarcodeTableRow
											key={b.id}
											barcode={b}
											skuid={skuid}
											triggerListUpdate={() => {
												barcodesQuery.remove();
												barcodesQuery.refetch();
											}}
										/>
									))}
							</>
						)}
					</Table.Tbody>
				</Table>
				{barcodesQuery.data && barcodesQuery.data?.value.length < 1 && (
					<>
						<Space h={25} />
						<Center w={'100%'}>
							<Text size="sm">No barcodes to display {':('}</Text>
						</Center>
					</>
				)}
			</ScrollArea>
		</>
	);
}
